module.exports = __webpack_public_path__ + "img/3.ee087c1a.jpg";